type RevokedFrom = { admin_email: string; group_name?: string | null; self_removed_admin?: boolean } | null | undefined;

type TOptions = { groupName: string; interpolation: { escapeValue: boolean } };

/**
 * Returns the translated revoked-access banner message when the subscriber's
 * group seat has been removed and group subscriptions are enabled; otherwise
 * undefined (no banner).
 *
 * The group name is publisher-authored, so it must skip i18next's HTML escaping or
 * "Tyler's Team" reaches the reader as "Tyler&#39;s Team". Older Swarm payloads omit
 * `group_name`; the admin-email fallback keeps the banner readable until Swarm catches up.
 *
 * `||` not `??`: an empty-string name is as useless to the reader as a missing one, and
 * would otherwise render the banner addressed to nobody.
 *
 * An admin who removes their own seat keeps the group: member copy would send them to their
 * group administrator, who is themselves, and sell them an upgrade they do not need.
 */
export const getRevokedAccessBannerText = (
  groupSubscriptionsEnabled: boolean,
  groupAccessRevokedFrom: RevokedFrom,
  t: (key: string, options: TOptions) => string,
): string | undefined => {
  if (!groupSubscriptionsEnabled || !groupAccessRevokedFrom) return undefined;

  const key = groupAccessRevokedFrom.self_removed_admin
    ? 'billing.current_plan.revoked_access_admin'
    : 'billing.current_plan.revoked_access';

  return t(key, {
    groupName: groupAccessRevokedFrom.group_name || groupAccessRevokedFrom.admin_email,
    interpolation: { escapeValue: false },
  });
};
